__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "freedom-reports-web";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@fontsource/poppins", "5.2.6", () => (__webpack_require__.e(176).then(() => (() => (__webpack_require__(90176))))));
			register("@hookform/resolvers", "3.3.4", () => (__webpack_require__.e(440).then(() => (() => (__webpack_require__(72440))))));
			register("@material-ui/core/styles", "4.12.4", () => (() => (__webpack_require__(30912))), 1);
			register("@material-ui/core", "4.12.4", () => (() => (__webpack_require__(57324))), 1);
			register("@material-ui/styles", "4.11.5", () => (() => (__webpack_require__(32152))), 1);
			register("@material-ui/system", "4.12.2", () => (() => (__webpack_require__(85968))), 1);
			register("@material-ui/utils", "4.11.3", () => (() => (__webpack_require__(56628))), 1);
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(664), __webpack_require__.e(248)]).then(() => (() => (__webpack_require__(87664))))));
			register("aws-amplify", "4.3.46", () => (Promise.all([__webpack_require__.e(52), __webpack_require__.e(572)]).then(() => (() => (__webpack_require__(70052))))));
			register("axios-retry", "0", () => (__webpack_require__.e(256).then(() => (() => (__webpack_require__(3875))))));
			register("axios", "0.26.0", () => (__webpack_require__.e(416).then(() => (() => (__webpack_require__(30416))))));
			register("axios", "0.26.0", () => (__webpack_require__.e(24).then(() => (() => (__webpack_require__(30024))))));
			register("axios", "0.27.2", () => (__webpack_require__.e(536).then(() => (() => (__webpack_require__(26536))))));
			register("react-cookie", "4.1.1", () => (__webpack_require__.e(232).then(() => (() => (__webpack_require__(80232))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(51292))), 1);
			register("react-hook-form", "7.51.0", () => (__webpack_require__.e(816).then(() => (() => (__webpack_require__(81816))))));
			register("react-notifications-component", "4.0.1", () => (__webpack_require__.e(196).then(() => (() => (__webpack_require__(76196))))));
			register("react-redux", "7.2.9", () => (__webpack_require__.e(640).then(() => (() => (__webpack_require__(92640))))));
			register("react-router-dom", "5.3.4", () => (__webpack_require__.e(712).then(() => (() => (__webpack_require__(62712))))));
			register("react", "18.2.0", () => (() => (__webpack_require__(69060))), 1);
			register("redux", "4.2.1", () => (__webpack_require__.e(348).then(() => (() => (__webpack_require__(91348))))));
			register("typeface-hind", "1.1.13", () => (__webpack_require__.e(776).then(() => (() => (__webpack_require__(93776))))));
			register("yup", "1.4.0", () => (__webpack_require__.e(568).then(() => (() => (__webpack_require__(14568))))));
			initExternal(30880);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};